import debounce from 'lodash.debounce';
import { useState, useEffect, useCallback, useMemo } from 'react';
/**
 * Hook that returns the current window size.
 * Allows on-demand syncing of values via the `sync` function.
 */
export const useWindowSize = ({
  delay = 250
} = {}) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const sync = useCallback(() => {
    const {
      innerWidth,
      innerHeight
    } = window;
    setWidth(innerWidth);
    setHeight(innerHeight);
  }, []);
  useEffect(() => {
    const debouncedSync = debounce(sync, delay);
    window.addEventListener('resize', debouncedSync);
    sync();
    return () => window.removeEventListener('resize', debouncedSync);
  }, [delay, sync]);
  return useMemo(() => ({
    height,
    sync,
    width
  }), [height, sync, width]);
};
//# sourceMappingURL=useWindowSize.js.map